import type { IErrorResponse } from '@/types/apis/Error';
import type { LessonListItem } from '@/types/apis/Lesson';
import type { PaginationResponse } from '@/types/PaginationResponse';

import {
  useInfiniteQuery,
  type UseInfiniteQueryResult,
} from '@tanstack/react-query';
import queryString from 'query-string';

import url from '@/statics/urls';
import api from '@/utils/api';
import {
  getNextPageParam,
  getPreviousPageParam,
} from '@/utils/infinitePaginationParams';

const useEducationContent = ({
  queries,
  enabled = true,
}: {
  queries: {
    category_id?: string;
    tag?: string;
    seen?: boolean;
    search?: string;
    pageSize?: number;
  };
  enabled?: boolean;
}): UseInfiniteQueryResult<
  {
    pageParams: { pageParams: { current: number } }[];
    pages: PaginationResponse<LessonListItem>[];
  },
  IErrorResponse
> => {
  return useInfiniteQuery({
    queryKey: [`${url.educationContents}?${queryString.stringify(queries)}`],
    queryFn: ({ pageParam }) => {
      return api.get(
        `${url.educationContents}?${queryString.stringify({
          current: pageParam.current as number,
          pageSize: 5,
          ...queries,
        })}`
      );
    },
    getNextPageParam,
    getPreviousPageParam,
    initialPageParam: { pageParam: { current: 1 } },
    enabled,
  });
};

export default useEducationContent;
